import { gql, useMutation } from '@apollo/client'
import { GetPaymentIntentClientSecretMutation, GetPaymentIntentClientSecretMutationVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

const getPaymentIntentClientSecretMutation = gql`
  ${cartFieldsFragment}

  mutation GetPaymentIntentClientSecret($cartId: ID!) {
    getPaymentIntentClientSecret(cartId: $cartId) {
      ...CartFields
    }
  }
`

export const useGetPaymentIntentClientSecret = () =>
  useMutation<GetPaymentIntentClientSecretMutation, GetPaymentIntentClientSecretMutationVariables>(getPaymentIntentClientSecretMutation, {
    fetchPolicy: 'no-cache'
  })
